// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"a35cb69f","453":"5565870f"}[chunkId] + ".chunk.js";
};